import { combineReducers } from 'redux';

import roundPlay from './reducers/roundPlayReducer';
import screen from './reducers/screenReducer';
import curriculum from './reducers/curriculumReducer';
import submittedAnswers from './reducers/submittedAnswersReducer';
import inference from './reducers/inferenceReducer';
import evidence from './reducers/evidenceReducer';
import VO from './reducers/VOReducer';
import saveData from './reducers/saveDataReducer';

// keeping the reducer collection as a separate exported object enables us
// to do some light test automation on every reducer.
// see ./reducers/__tests__/reducerRejections.test.js
// for more details.
export const reducerCollection = {
  screen,
  roundPlay,
  curriculum,
  submittedAnswers,
  inference,
  evidence,
  VO,
  saveData,
};

const reducers = combineReducers({ ...reducerCollection });

export default reducers;
